export default function RealResultsSection() {
  const beforeAfterResults = [
    {
      id: 1,
      title: 'Interior Deep Clean Transformation',
      beforeImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/544d7cc9f7d73dbb2718def1cf828ff3.png',
      afterImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/5926d20704f3d28d7a04a66b11b82fe3.png',
      description: 'Complete interior restoration with deep cleaning and conditioning'
    },
    {
      id: 2,
      title: 'Seat Extraction Interior Transformation',
      beforeImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/7e48f8584fa7ff72e2f8c2845fb767cb.png',
      afterImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/4397377cb59abc93035ddbdee2652210.png',
      description: 'Professional seat extraction cleaning for deep stain removal and restoration'
    },
    {
      id: 3,
      title: 'Exterior Wash and Wax',
      beforeImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/499ac682b5271bdbcf3bde106d6e41d2.png',
      afterImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/8faa8d11d2610ca57ad1b10afae306bc.png',
      description: 'Professional exterior wash and protective wax application for lasting shine'
    },
    {
      id: 4,
      title: 'Rim Deep Clean and Polish',
      beforeImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/1dbb96f803219a4db882e40515b2282a.png',
      afterImage: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/96e2e41531a0dc837fa9098142f7e317.png',
      description: 'Professional rim deep cleaning and polishing for mirror-like finish'
    }
  ];

  const transformations = [
    {
      title: "Interior Deep Clean Transformation",
      description: "Complete interior detailing with deep cleaning, conditioning, and protection",
      beforeImage: "https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/544d7cc9f7d73dbb2718def1cf828ff3.png",
      afterImage: "https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/5926d20704f3d28d7a04a66b11b82fe3.png",
      beforeAlt: "Car interior before professional detailing - dirty and worn",
      afterAlt: "Car interior after professional detailing - clean and pristine"
    },
  ];

  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            <strong>Real Results</strong>
          </h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            See the incredible transformations we achieve with our professional mobile detailing services
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {beforeAfterResults.map((result) => (
            <div key={result.id} className="bg-gray-900 rounded-xl shadow-lg overflow-hidden border border-gray-800">
              <div className="p-6">
                <h4 className="text-xl font-bold text-white mb-4 text-center">
                  <strong>{result.title}</strong>
                </h4>
                
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="relative">
                    <img 
                      src={result.beforeImage}
                      alt={`Before ${result.title} - Mobile car detailing Melbourne`}
                      title={`Before ${result.title} - Starlight Motors`}
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                    <div className="absolute top-2 left-2 bg-red-600 text-white px-3 py-1 rounded-full font-semibold text-sm">
                      Before
                    </div>
                  </div>
                  
                  <div className="relative">
                    <img 
                      src={result.afterImage}
                      alt={`After ${result.title} - Mobile car detailing Melbourne`}
                      title={`After ${result.title} - Starlight Motors`}
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                    <div className="absolute top-2 left-2 bg-green-600 text-white px-3 py-1 rounded-full font-semibold text-sm">
                      After
                    </div>
                  </div>
                </div>
                
                <p className="text-gray-400 text-center text-sm">
                  {result.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-300 mb-6">
            <strong>Ready to see these results on your vehicle?</strong>
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Book Your Transformation Today
          </button>
        </div>
      </div>
    </section>
  );
}
